import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/video_ico.png'
import _imports_1 from '../assets/images/video-cover.png?v=1'
import _imports_2 from '../assets/images/play-btn.png'
import _imports_3 from '../assets/images/scan-no-data.png'
import _imports_4 from '../assets/images/loading.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-cf7dc928"),n=n(),_popScopeId(),n)
const _hoisted_1 = { "talqs-app": "" }
const _hoisted_2 = { class: "question-result-container" }
const _hoisted_3 = { class: "scan-header" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header-ico" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1))
const _hoisted_5 = { class: "video-title" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gray-line" }, null, -1))
const _hoisted_7 = { class: "result-container pb" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "left-line" }),
  /*#__PURE__*/_createTextVNode("视频解析")
], -1))
const _hoisted_9 = { class: "result-con" }
const _hoisted_10 = ["src"]
const _hoisted_11 = {
  key: 1,
  src: _imports_1,
  class: "result-img"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "video-btn"
}, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "left-line" }),
  /*#__PURE__*/_createTextVNode("题目")
], -1))
const _hoisted_14 = { class: "result-con" }
const _hoisted_15 = {
  ref: "question_title",
  id: "question_title"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "question-line" }, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "left-line" }),
  /*#__PURE__*/_createTextVNode("图文解析")
], -1))
const _hoisted_18 = { class: "result-con" }
const _hoisted_19 = {
  ref: "question_analysis",
  id: "question_analysis"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both","height":"0","overflow":"hidden"} }, null, -1))
const _hoisted_21 = {
  key: 1,
  class: "no-question-data"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  class: "scan-no-data"
}, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "no-data-txt" }, "非常抱歉！这道题目暂时还没有讲解哦~", -1))
const _hoisted_24 = [
  _hoisted_22,
  _hoisted_23
]
const _hoisted_25 = {
  key: 2,
  class: "my-loading"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_4 }, null, -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "内容加载中…", -1))
const _hoisted_28 = [
  _hoisted_26,
  _hoisted_27
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.isLoadingComplete && _ctx.videoData && (_ctx.hasVideo || _ctx.hasResolve))
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.videoData.title), 1)
            ]),
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              (_ctx.hasVideo)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _hoisted_8,
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", {
                        class: "video-box",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.playVideo()))
                      }, [
                        (_ctx.videoData.good_img)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: _ctx.videoData.good_img,
                              class: "result-img"
                            }, null, 8, _hoisted_10))
                          : (_openBlock(), _createElementBlock("img", _hoisted_11)),
                        _hoisted_12
                      ])
                    ])
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _hoisted_13,
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, null, 512)
                    ]),
                    _hoisted_16,
                    _hoisted_17,
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, null, 512),
                      _hoisted_20
                    ])
                  ], 64))
            ])
          ], 64))
        : _createCommentVNode("", true),
      (!_ctx.hasVideo && !_ctx.hasResolve)
        ? (_openBlock(), _createElementBlock("div", _hoisted_21, _hoisted_24))
        : _createCommentVNode("", true),
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_25, _hoisted_28))
        : _createCommentVNode("", true)
    ])
  ]))
}